<template>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <h6 class="modal-title">{{dialogType == 'add'?globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?'Add '+globalSettingsFromStartup.department_alias.alias_name:"Add Department":globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?'Edit selected '+globalSettingsFromStartup.department_alias.alias_name:"Edit selected Department"}}</h6>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
      width: 30px !important;
      color: #fff;"></cancel-icon></span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <input @keyup.enter="updateSourceName()" id="field-focus" ref="fieldSelectionRef" v-model="sourceName" type="text" class="bg-transparent border rounded text-light form-control input-fields">
            <div v-if="dialogType == 'add'" class="config-desc mt-1">
                    You can add multiple sources with comma(,) seperation.
              </div> -->



               <div class="h-100" style="overflow:auto" ref="generalTab">
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                        <div>
                            <label>{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}} {{$t('Name')}} <span style="color:#858585"> *</span></label>
                        </div>
                        <input v-model="sourceName" @change="isNameEditing=true" ref="fieldSelectionRef" type="text" :placeholder="globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?'Enter '+globalSettingsFromStartup.department_alias.alias_name+ ' name':'Enter Department name'"
                        deselectLabel=""  class="bg-transparent rounded text-light input-text-field add-border"/>
                    </div>
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                        <div>
                            <label>{{$t('Logo')}}</label>
                        </div>
                        <div style="display: flex;justify-content: center;">
                            <div class="profile-image-upload-wrapper">
                                <div class="profile-image-display hover-to-show-delete-icon">
                                    <img v-if="imageType == 'image'" :src="getProxyConvertedURL(logoPath)" style="height:100%;width:100%">
                                    <svg v-else-if="imageType == null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="height: 100% !important;width: 100% !important;color: #4e4e4e;padding:0px 7px">
                                      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                                      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                                    </svg>
                                    <canvas v-else-if="imageType == 'canvas'" ref="preferenceUploadCanvas" style="border-radius:5px;" id="canvas"></canvas>
                                    <cancel-icon v-if="imageType" @click="imageType = null;uploadedImage = 'remove logo';isLogoEditing=true" class="delete-icon"></cancel-icon>
                                  </div>
                                <div class="upload-profile-image-button">
                                    <div class="btn-wrapper">
                                    <button class="btn btn-outline-secondary" data-v-198e7d7f="">{{$t('Upload')}}</button>
                                    <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                    <input type="file"
                                        id="img-input"
                                        ref="uploadFile"
                                        @change="uploadLogoImage($event)"
                                        accept="image/*"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
              </div>
          </div>
          <div class="modal-footer p-0 primary-btn-style">
            <button class="btn btn-outline-secondary mr-1" data-dismiss="modal" @click="close">{{$t('Cancel')}}</button>
            <button class="btn btn-outline-primary mr-2" @click='updateSourceName()'>{{$t('Save')}}</button>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import {mapActions} from "vuex"
  import cancelIcon from "../core/InlineCancelField.vue"
  
  export default {
    props:['dialogType',"selectedSource"],
    data() {
      return {
        sourceName:"",
        logoPath:"",
        show:false,
        imageType:null,
        uploadedImage:"",
        isNameEditing:false,
        isLogoEditing:false,
        PROFILE_IMAGE_ALLOWED_WIDTH:128,
      };
    },
    computed:{
        globalSettingsFromStartup:{
          get(){
            return this.$store.state.startUpData.startUpDataDetails;
          }
        },
    },
    watch: {
      'show': function (val) {
        if (val) {
            this.$nextTick(() => {
              setTimeout(() => {
                  this.$refs.fieldSelectionRef.focus()
              }, 50);
          })
        }
      }
    },
    components:{
          'cancel-icon':cancelIcon
      },
    methods : {

      uploadLogoImage(ev){
        this.imageType = "canvas";
        let file = ev.target.files[0]; // get the file
        let blobURL = URL.createObjectURL(file);
        this.drawImage(blobURL,false)
      },

      drawImage(blobURL){
        this.imageType = "canvas";
        let img = new Image();
        img.src = blobURL;
        img.onerror = ()=> {
            URL.revokeObjectURL(this.src);
            // Handle the failure properly
            alert.log("Could not able to load selected image.");
        };
        img.onload = ()=> {
            URL.revokeObjectURL(this.src);
            let wrh = img.naturalWidth / img.naturalHeight;
            let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
            let canvas = this.$refs.preferenceUploadCanvas;
            canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
            canvas.height = calculatedImageHeightAsPerAspectRatio
            canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);
            this.$nextTick(()=>{
                this.uploadedImage = canvas.toDataURL();
                this.isLogoEditing = true;
            });
        };
      },



      updateSourceName(){
          if(this.sourceName == null || this.sourceName.trim().length <= 0){
            alert(`${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"}`+" with empty name is not supported.\nPlease enter valid "+`${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"}`+ " name.");
            return false;
          }
          if(this.dialogType == 'add'){
          // let projectsList = this.sourceName.split(",")
          // projectsList = projectsList.filter(function (e) {return e.length != 0;});
          // if(projectsList.length > 0){
          //   let i = 0;
          //   while (i < projectsList.length) {
          //     let payload = { name:projectsList[i] }
          //     this.createDepartment(payload).then((data) => {
          //       if (data.statusCode==200){
          //         this.$toast.success(data.message);
          //         this.close()
          //       }else{
          //         this.$toast.error(data.message);
          //       }
          //     }),
          //     i++
          //   }
          // }
          let sourceName = this.sourceName.trim();
            if(sourceName == ""){
                alert("Empty"+ `${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"}` +"Name");
                return false;
            }
            let payload = {};
            payload['name'] = this.sourceName;
            if(this.uploadedImage){
              if(this.uploadedImage.includes('remove logo')){
                payload["logo"] = '';
              }else{
                payload["logo"] = this.uploadedImage;
              }
            }
            this.createDepartment(payload).then((data) => {
              if (data.statusCode==200){
                this.$toast.success(data.message);
                this.close();
              }else{
                this.$toast.error(data.message);
              }
            });  
          }else{
            let payload = {};
            let params = {};
            payload['_id'] = this.selectedSource._id;
            if(this.isNameEditing){
              params['name'] = this.sourceName;
            }
            if(this.uploadedImage && this.isLogoEditing){
              if(this.uploadedImage.includes('remove logo')){
                params["logo"] = '';
              }else{
                params["logo"] = this.uploadedImage;
              }
            }
            payload["params"] = params;
            this.updateDepartmentInfo(payload).then((data) => {
              if (data.statusCode==200){
                this.$toast.success(data.message);
                this.close();
              }else{
                this.$toast.error(data.message);
              }
              this.uploadedImage = '';
            })
          }
      },
      close(){
        this.sourceName = "";
        this.uploadedImage = null;
        this.isLogoEditing = false;
        this.isNameEditing = false;
        this.$emit('close')
      },
      ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo"]),
    },
    mounted(){
      setTimeout(() => {
        this.show = true;
      }, 200)
      if(this.dialogType == 'edit' && this.selectedSource){
        this.sourceName = this.selectedSource.name;
        if('logo' in this.selectedSource && this.selectedSource.logo){
          this.logoPath = this.selectedSource.logo;
          this.imageType = "image";
        }
      }
    },
  };
</script>
  
  
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $icon-hover:#2c3339;
  
  .modal-dialog {
      max-width: 600px;
      width: 420px;
      margin: 0;
      padding: 0;
    }
    
    .modal-content {
      height: auto;
      min-height: 100%;
      border: 0 none;
      border-radius: 0;
      box-shadow: none;
      background: $primary-background !important;
      border: $secondary-border-color;
      .modal-body{
        background: $primary-background;
      }
    }
  
  .modal {
    text-align: center;
    padding: 0!important;
    display:block;
  }
  .modal-header .close {
      // margin: -1rem -13px -1rem auto !important;
       margin:0px !important;
    padding: 0px !important;
  }
  .modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-inline-end: -4px;
  }
  .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
  }
  
  .btn{
      font-size:14px !important;
      height:100%;
  }
  
  .border{
      border: $border-color !important;
  }
  
  .modal-header,.modal-footer{
      border-top: $secondary-border-color !important;
      border-bottom: $secondary-border-color !important;
      background: $secondary-background-color;
      height: 58px;
      align-items: center;
      .modal-title{
        color:$text-color;
      }
  }
  
  .primary-btn-style{
      margin-top:1%;
      button{
          height: 35px;
          width: 70px;
          font-size:14px;
      }
  }
  
  .secondary-btn-style{
    color:$text-color;
  }
  
  .key-style {
    color: $dull-text-color;
    width: 30%;
    text-align: start;
    font-size: $input-field-and-label-font-size;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 3px;
  }
  
  .input-fields {
    border: none !important;
    border-bottom: 1px solid $active-blue !important;
    height:30px;
  }
  
  .input-fields:focus {
    outline: unset;
    box-shadow:none;
  }
  
  .close-icon:hover{
    background: $icon-hover;
    border-radius: 20px;
  }
  .config-desc{
    color: $dull-text-color;
    font-size:12px;
  }

  .profile-image-upload-wrapper{
        // padding:30px;
        .profile-image-display{
            height: auto;
            width: 130px;
            border: 1px solid #3a3a3a;
            border-radius: 10px;
            margin: auto;
            position:relative;
            .canvas{
                    height: 100%;
                    width: 100%;
                    border-radius: 5px;
            }
        }
        .upload-profile-image-button{
            padding: 8px 0px;
            margin: 0 auto;
            display: inline-block;
            .btn-wrapper{
                // margin-bottom: 8px;
                width: 170px;
                position: relative;
                margin: auto;
                display: inline-flex;
                justify-content: center;
                
                button{
                  width:96%;
                }
            }
        }
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 60%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }

    .add-border{
      border: $border-color;
    }
    .delete-icon{
      position: absolute;
      inset-inline-end: -4px;
      top: -4px;
      height: 23px;
      width: 23px;
      border: $border-color;
      background: $primary-background;
      border-radius: 30px;
      color: $text-color;
    }
    .delete-icon{
      visibility: hidden;
    }
    .hover-to-show-delete-icon:hover{
      box-shadow: 0px 0px 0px 1px rgba(58,58,58,1);
      .delete-icon{
          visibility:visible;
      }
    }
    .hover-to-show-delete-icon{
      position:relative;
      padding:2px;
    }
  
  </style>